import { render, staticRenderFns } from "./CompositionStep2.vue?vue&type=template&id=1ddfeac3&"
import script from "./CompositionStep2.vue?vue&type=script&lang=js&"
export * from "./CompositionStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports